// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_login_email = /** @type {(inputs: {}) => string} */ () => {
	return `Email`
};

const de_widget_login_email = /** @type {(inputs: {}) => string} */ () => {
	return `E-Mail`
};

const es_widget_login_email = /** @type {(inputs: {}) => string} */ () => {
	return `Correo Electrónico`
};

const fr_widget_login_email = /** @type {(inputs: {}) => string} */ () => {
	return `Email`
};

const fi_widget_login_email = /** @type {(inputs: {}) => string} */ () => {
	return `Sähköposti`
};

const hi_widget_login_email = /** @type {(inputs: {}) => string} */ () => {
	return `ईमेल`
};

const ja_widget_login_email = /** @type {(inputs: {}) => string} */ () => {
	return `メールアドレス`
};

const nl_widget_login_email = /** @type {(inputs: {}) => string} */ () => {
	return `E-mail`
};

const pt_widget_login_email = /** @type {(inputs: {}) => string} */ () => {
	return `Email`
};

const ro_widget_login_email = /** @type {(inputs: {}) => string} */ () => {
	return `Email`
};

const th_widget_login_email = /** @type {(inputs: {}) => string} */ () => {
	return `อีเมล`
};

const ur_widget_login_email = /** @type {(inputs: {}) => string} */ () => {
	return `ای میل`
};

const zh_hant1_widget_login_email = /** @type {(inputs: {}) => string} */ () => {
	return `電子郵件`
};

const da_widget_login_email = /** @type {(inputs: {}) => string} */ () => {
	return `E-mail`
};

const it_widget_login_email = /** @type {(inputs: {}) => string} */ () => {
	return `Email`
};

const vn_widget_login_email = /** @type {(inputs: {}) => string} */ () => {
	return `Email`
};

const ko_widget_login_email = /** @type {(inputs: {}) => string} */ () => {
	return `이메일`
};

const tr_widget_login_email = /** @type {(inputs: {}) => string} */ () => {
	return `E-posta`
};

const lv_widget_login_email = /** @type {(inputs: {}) => string} */ () => {
	return `E-pasts`
};

const ar_widget_login_email = /** @type {(inputs: {}) => string} */ () => {
	return `البريد الإلكتروني`
};

const bs_widget_login_email = /** @type {(inputs: {}) => string} */ () => {
	return `Email`
};

const sl_widget_login_email = /** @type {(inputs: {}) => string} */ () => {
	return `E-pošta`
};

const id_widget_login_email = /** @type {(inputs: {}) => string} */ () => {
	return `Email`
};

const sv_widget_login_email = /** @type {(inputs: {}) => string} */ () => {
	return `E-post`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_login_email = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_login_email(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_login_email", locale)
	if (locale === "en") return en_widget_login_email(inputs)
	if (locale === "de") return de_widget_login_email(inputs)
	if (locale === "es") return es_widget_login_email(inputs)
	if (locale === "fr") return fr_widget_login_email(inputs)
	if (locale === "fi") return fi_widget_login_email(inputs)
	if (locale === "hi") return hi_widget_login_email(inputs)
	if (locale === "ja") return ja_widget_login_email(inputs)
	if (locale === "nl") return nl_widget_login_email(inputs)
	if (locale === "pt") return pt_widget_login_email(inputs)
	if (locale === "ro") return ro_widget_login_email(inputs)
	if (locale === "th") return th_widget_login_email(inputs)
	if (locale === "ur") return ur_widget_login_email(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_login_email(inputs)
	if (locale === "da") return da_widget_login_email(inputs)
	if (locale === "it") return it_widget_login_email(inputs)
	if (locale === "vn") return vn_widget_login_email(inputs)
	if (locale === "ko") return ko_widget_login_email(inputs)
	if (locale === "tr") return tr_widget_login_email(inputs)
	if (locale === "lv") return lv_widget_login_email(inputs)
	if (locale === "ar") return ar_widget_login_email(inputs)
	if (locale === "bs") return bs_widget_login_email(inputs)
	if (locale === "sl") return sl_widget_login_email(inputs)
	if (locale === "id") return id_widget_login_email(inputs)
	if (locale === "sv") return sv_widget_login_email(inputs)
	return "widget_login_email"
};